import { ColorConverter, ObjectCreator } from "../../../../../../../../web-graphics";
import { SettingsParser } from "../../../settings-parser";
import { SimpleVisualizatorSettings } from "../../../../settings/simple-visualizator-settings";

export class SignalsPlotContentParser extends SettingsParser {
  constructor() {
    super();
  }

  static createSettings(settings, defaultSettings) {
    if (settings === undefined) {
      return undefined;
    }
    let parsedSettings = ObjectCreator.merge(settings, defaultSettings);
    if (parsedSettings?.labels?.color !== undefined) {
      let parsedColor = ColorConverter.convertToWebglRgba(parsedSettings.labels.color);
      parsedSettings.labels.color = parsedColor.value;
    }
    if (parsedSettings.scaleX === undefined) {
      parsedSettings.scaleX = {};
    }
    if (parsedSettings.scaleY === undefined) {
      parsedSettings.scaleY = {};
    }
    if (parsedSettings.scaleX.values === undefined && parsedSettings.scaleX.defaultValues !== undefined) {
      parsedSettings.scaleX.values = ObjectCreator.deepCopy(parsedSettings.scaleX.defaultValues);
    }
    if (parsedSettings.scaleY.values === undefined && parsedSettings.scaleY.defaultValues !== undefined) {
      parsedSettings.scaleY.values = ObjectCreator.deepCopy(parsedSettings.scaleY.defaultValues);
    }
    if (parsedSettings.scaleX.currIndex === undefined && parsedSettings.scaleX.defaultIndex !== undefined) {
      parsedSettings.scaleX.currIndex = parsedSettings.scaleX.defaultIndex;
    }
    if (parsedSettings.scaleY.currIndex === undefined && parsedSettings.scaleY.defaultIndex !== undefined) {
      parsedSettings.scaleY.currIndex = parsedSettings.scaleY.defaultIndex;
    }
    if (
      parsedSettings.scaleX.currValue === undefined &&
      parsedSettings.scaleX.currIndex !== undefined &&
      parsedSettings.scaleX.values !== undefined
    ) {
      parsedSettings.scaleX.currValue = parsedSettings.scaleX.values[parsedSettings.scaleX.currIndex];
    }
    if (
      parsedSettings.scaleY.currValue === undefined &&
      parsedSettings.scaleY.currIndex !== undefined &&
      parsedSettings.scaleY.values !== undefined
    ) {
      parsedSettings.scaleY.currValue = parsedSettings.scaleY.values[parsedSettings.scaleY.currIndex];
    }
    return parsedSettings;
  }

  parse(settings, defaultSettings) {
    let parsedSettings = SignalsPlotContentParser.createSettings(settings, defaultSettings);
    if (parsedSettings === undefined) {
      return undefined;
    }
    return new SimpleVisualizatorSettings(parsedSettings);
  }
}
